import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/api';

const FormularioDevedor = () => {
    const navigate = useNavigate();

    const [credores, setCredores] = useState([]);
    const [loadingCredores, setLoadingCredores] = useState(true);

    // Estado atualizado para refletir todos os campos do DTO Java
    const [dados, setDados] = useState({
        credorId: '',
        nome: '',
        cpfCnpj: '',
        telefone: '', 
        email: '',    
        valorDivida: '',
        descricao: '',
        dataVencimentoOriginal: '',
        negativado: false,
        emAcaoJudicial: false,
        numeroProcesso: '',
        observacoesInternas: '',
        percentualMulta: '2',     // Default 2%
        percentualJurosMes: '1'   // Default 1%
    });

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        api.get('/assinante/credores')
            .then(res => {
                setCredores(res.data);
                setLoadingCredores(false);
            })
            .catch(err => {
                console.error("Erro ao buscar credores:", err);
                setLoadingCredores(false);
            });
    }, []);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        
        setDados(prev => {
            const novosDados = { 
                ...prev, 
                [name]: type === 'checkbox' ? checked : value 
            };
            
            // Lógica de UX: Se desmarcar processo judicial, limpa o número do processo
            if (name === 'emAcaoJudicial' && !checked) {
                novosDados.numeroProcesso = '';
            }
            
            return novosDados;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        // Prepara o payload convertendo os valores numéricos
        const payload = {
            ...dados,
            valorDivida: parseFloat(dados.valorDivida),
            percentualMulta: parseFloat(dados.percentualMulta || 2),
            percentualJurosMes: parseFloat(dados.percentualJurosMes || 1)
        };

        try {
            await api.post('/assinante/devedores', payload);
            alert("Devedor cadastrado com sucesso! O sistema calculou os juros automaticamente.");
            navigate('/dashboard'); 
        } catch (error) {
            console.error("Erro ao cadastrar:", error.response?.data);
            alert("Erro ao cadastrar. Verifique os dados.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.contentWrapper}>
                
                <button onClick={() => navigate('/dashboard')} style={styles.btnVoltar}>
                    ← Voltar ao Dashboard
                </button>

                <form onSubmit={handleSubmit} style={styles.form}>
                    <h3 style={{color: 'white', marginBottom: '20px', marginTop: 0}}>Novo Devedor / Dívida</h3>
                    
                    {loadingCredores ? (
                        <p style={{color: '#94a3b8'}}>A carregar lista de credores...</p>
                    ) : (
                        <select name="credorId" value={dados.credorId} onChange={handleChange} style={styles.input} required>
                            <option value="" disabled>Selecione o Credor/Clínica...</option>
                            {credores.map(credor => (
                                <option key={credor.id} value={credor.id}>{credor.nomeExibicao}</option>
                            ))}
                        </select>
                    )}

                    <div style={styles.row}>
                        <div style={{ flex: '2 1 250px' }}>
                            <input name="nome" placeholder="Nome Completo do Devedor" onChange={handleChange} style={styles.input} required />
                        </div>
                        <div style={{ flex: '1 1 150px' }}>
                            <input name="cpfCnpj" placeholder="CPF ou CNPJ" onChange={handleChange} style={styles.input} required />
                        </div>
                    </div>
                    
                    <div style={styles.row}>
                        <div style={{ flex: '1 1 200px' }}>
                            <input name="telefone" placeholder="WhatsApp (Ex: 81999999999)" onChange={handleChange} style={styles.input} required />
                        </div>
                        <div style={{ flex: '1 1 200px' }}>
                            <input name="email" type="email" placeholder="E-mail (Opcional)" onChange={handleChange} style={styles.input} />
                        </div>
                    </div>
                    
                    <div style={styles.divider}></div>
                    
                    <input name="descricao" placeholder="Descrição da Dívida (Ex: Mensalidade ref. Jan/2026)" onChange={handleChange} style={styles.input} required />
                    
                    <div style={styles.row}>
                        <div style={{ flex: '1 1 200px' }}>
                            <label style={styles.label}>Valor Original (R$)</label>
                            <input name="valorDivida" type="number" step="0.01" placeholder="Ex: 1500.00" onChange={handleChange} style={styles.input} required />
                        </div>
                        <div style={{ flex: '1 1 200px' }}>
                            <label style={styles.label}>Vencimento Original</label>
                            <input name="dataVencimentoOriginal" type="date" onChange={handleChange} style={styles.input} required />
                        </div>
                    </div>

                    {/* NOVOS CAMPOS: TAXAS E JUROS */}
                    <div style={styles.row}>
                        <div style={{ flex: '1 1 200px' }}>
                            <label style={styles.label}>Multa por atraso (%)</label>
                            <input name="percentualMulta" type="number" step="0.01" value={dados.percentualMulta} onChange={handleChange} style={styles.input} />
                        </div>
                        <div style={{ flex: '1 1 200px' }}>
                            <label style={styles.label}>Juros ao mês (%)</label>
                            <input name="percentualJurosMes" type="number" step="0.01" value={dados.percentualJurosMes} onChange={handleChange} style={styles.input} />
                        </div>
                    </div>

                    {/* NOVO CAMPO: OBSERVAÇÕES INTERNAS */}
                    <div>
                        <label style={styles.label}>Observações Internas (Não aparece para o devedor)</label>
                        <textarea 
                            name="observacoesInternas" 
                            placeholder="Anotações para a sua equipa..." 
                            onChange={handleChange} 
                            style={styles.textarea} 
                            rows="2"
                        />
                    </div>

                    <div style={styles.checkboxGroup}>
                        <label style={styles.checkboxLabel}>
                            <input type="checkbox" name="negativado" checked={dados.negativado} onChange={handleChange} />
                            Nome Negativado (Serasa/SPC)
                        </label>
                        <label style={styles.checkboxLabel}>
                            <input type="checkbox" name="emAcaoJudicial" checked={dados.emAcaoJudicial} onChange={handleChange} />
                            Já possui processo judicial
                        </label>
                    </div>

                    {/* RENDERIZAÇÃO CONDICIONAL: Só aparece se emAcaoJudicial for true */}
                    {dados.emAcaoJudicial && (
                        <div>
                            <label style={{...styles.label, color: '#f59e0b'}}>Número do Processo Judicial</label>
                            <input 
                                name="numeroProcesso" 
                                placeholder="Ex: 0001234-56.2026.8.17.0000" 
                                onChange={handleChange} 
                                value={dados.numeroProcesso}
                                style={{...styles.input, border: '1px solid #f59e0b'}} 
                                required 
                            />
                        </div>
                    )}

                    <button type="submit" disabled={loading || loadingCredores} style={styles.button}>
                        {loading ? 'A Guardar...' : 'Cadastrar Devedor'}
                    </button>
                </form>
            </div>
        </div>
    );
};

const styles = {
    container: { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#020617', padding: '20px' },
    contentWrapper: { width: '100%', maxWidth: '600px' },
    btnVoltar: { background: 'transparent', color: '#94a3b8', border: 'none', cursor: 'pointer', fontSize: '0.95rem', marginBottom: '15px', padding: 0, display: 'inline-block', textAlign: 'left' },
    form: { display: 'flex', flexDirection: 'column', gap: '15px', background: 'rgba(255,255,255,0.05)', padding: '30px', borderRadius: '12px', width: '100%', boxSizing: 'border-box' },
    label: { display: 'block', color: '#94a3b8', fontSize: '0.85rem', marginBottom: '5px' },
    input: { background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', padding: '12px', borderRadius: '8px', color: 'white', fontSize: '1rem', width: '100%', boxSizing: 'border-box' },
    textarea: { background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', padding: '12px', borderRadius: '8px', color: 'white', fontSize: '1rem', width: '100%', boxSizing: 'border-box', resize: 'vertical', fontFamily: 'inherit' },
    row: { display: 'flex', gap: '15px', flexWrap: 'wrap' },
    divider: { height: '1px', background: 'rgba(255,255,255,0.1)', margin: '10px 0' },
    checkboxGroup: { display: 'flex', flexDirection: 'column', gap: '10px', padding: '15px', background: 'rgba(255,255,255,0.02)', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.05)' },
    checkboxLabel: { color: '#94a3b8', display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', fontSize: '0.95rem' },
    button: { background: '#10b981', color: '#022c22', padding: '15px', borderRadius: '8px', border: 'none', fontWeight: 'bold', cursor: 'pointer', marginTop: '10px', fontSize: '1rem', transition: 'background 0.3s' }
};

export default FormularioDevedor;